<template>
  <span
    class="inline-flex items-center px-2 py-0.5 rounded text-sm font-medium bg-amber-100 text-amber-700"
  >
    {{ label }}
  </span>
</template>

<script>
export default {
  name: "WarningBadge",
  props: ["label"],
};
</script>
